import React from 'react';
import { Instagram, Facebook, Twitter, Linkedin, Youtube, MessageCircleMore } from 'lucide-react';

const SocialMediaLinks = ({ socialMedia, mode = 'light' }) => {
    const iconColor = mode === 'light' ? 'black' : 'white';

    const renderSocialMediaIcon = (name) => {
        switch (name) {
            case 'instagram':
                return <Instagram color={iconColor} className="w-6 h-6" />;
            case 'facebook':
                return <Facebook color={iconColor} className="w-6 h-6" />;
            case 'twitter':
                return <Twitter color={iconColor} className="w-6 h-6" />;
            case 'linkedin':
                return <Linkedin color={iconColor} className="w-6 h-6" />;
            case 'youtube':
                return <Youtube color={iconColor} className="w-6 h-6" />;
            case 'whatsapp':
                return <MessageCircleMore color={iconColor} className="w-6 h-6" />;
            default:
                return null;
        }
    };

    return (
        <div className="d-flex justify-content-center">
            {socialMedia.map((platform) => (
                <a
                    key={platform.id}
                    href={platform.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-decoration-none text-dark me-3"
                >
                    {renderSocialMediaIcon(platform.name)}
                </a>
            ))}
        </div>
    );
};

export default SocialMediaLinks;